(function dynamicTextAreaDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlTextArea', [])
        .directive('dynamicTextArea', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-text-area/custom-control-text-area-template.html'
            };
        });
})();